module.exports = __webpack_public_path__ + "img/red_038.c6d7258e.png";